import { Action } from '@ngrx/store';

import { AutocompleteRequest, FullAddressDetails, Prediction } from './geo-coder.models';

export enum GeoCoderActionTypes {
  INIT_GEOCODER_STATE = '[Geo Coder] Init Geo Coder State',

  GET_AUTOCOMPLETE_RESULTS = '[Geo Coder] Get Autocomplete Results',
  GET_AUTOCOMPLETE_RESULTS_SUCCESS = '[Geo Coder] Get Autocomplete Results Success',
  GET_AUTOCOMPLETE_RESULTS_FAIL = '[Geo Coder] Get Autocomplete Results Fail',

  GET_SELECTED_ADDRESS_DETAILS = '[Geo Coder] Get Selected Address Details',
  GET_SELECTED_ADDRESS_DETAILS_SUCCESS = '[Geo Coder] Get Selected Address Details Success',
  GET_SELECTED_ADDRESS_DETAILS_FAIL = '[Geo Coder] Get Selected Address Details Fail',

  SET_SELECTED_SHOP = '[Geo Coder] Set User Selected Shop',
  SET_FULL_ADDRESS = '[Geo Coder] Set Full Address'
}

export class InitGeoCoderStateAction implements Action {
  readonly type = GeoCoderActionTypes.INIT_GEOCODER_STATE;
  constructor(public payload?: any) {}
}

export class GetAutocompleteResultsAction implements Action {
  readonly type = GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS;
  constructor(public payload: AutocompleteRequest) {}
}

export class GetAutocompleteResultsSuccessAction implements Action {
  readonly type = GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS_SUCCESS;
  constructor(public payload: Prediction[]) {}
}

export class GetAutocompleteResultsFailAction implements Action {
  readonly type = GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS_FAIL;
  constructor(public payload: any) {}
}

export class GetSelectedAddressDetailsAction implements Action {
  readonly type = GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS;
  constructor(public payload: string) {}
}

export class GetSelectedAddressDetailsSuccessAction implements Action {
  readonly type = GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS_SUCCESS;
  constructor(public payload: FullAddressDetails) {}
}

export class GetSelectedAddressDetailsFailAction implements Action {
  readonly type = GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS_FAIL;
  constructor(public payload: any) {}
}

export class SetSelectedShopAction implements Action {
  readonly type = GeoCoderActionTypes.SET_SELECTED_SHOP;
  constructor(public payload: any) {}
}
export class SetFullAddressAction implements Action {
  readonly type = GeoCoderActionTypes.SET_FULL_ADDRESS;
  constructor(public payload: FullAddressDetails) {}
}

export type GeoCoderActions =
  | InitGeoCoderStateAction
  | GetAutocompleteResultsAction
  | GetAutocompleteResultsSuccessAction
  | GetAutocompleteResultsFailAction
  | GetSelectedAddressDetailsAction
  | GetSelectedAddressDetailsSuccessAction
  | GetSelectedAddressDetailsFailAction
  | SetSelectedShopAction
  | SetFullAddressAction;
